import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';

export function valueOrDefault(value) {
  switch (value) {
    case 'none':
    case undefined:
    case null:
      return 'unregisteredValue';
    default:
      return value;
  }
}

const AccionaTableDeliveryROW = ({ datas, text_align, type }) => {
  const intl = useIntl();
  const positionText = text_align || 'left';
  const typeRow = type || 1;

  const keysLabel = Object.keys(datas);
  const keysValues = Object.values(datas);
  const colspan = 12 / keysLabel.length;
  let percentageWidth = (colspan / 12) * 100;
  percentageWidth = percentageWidth + '%';

  const formatLabel = (label) => {
    let labelFormeted = '';
    if (label.substring(0, 5) === 'attr_') {
      labelFormeted = intl.formatMessage({
        id: `attr.${label.substring(5, label.length)}`,
      });
    } else {
      labelFormeted = intl.formatMessage({ id: label });
    }

    return labelFormeted;
  };

  if (typeRow === 1) {
    return (
      <>
        <tr>
          {keysLabel.map((label) => {
            let labelText = formatLabel(label);

            return (
              <td
                key={label}
                colSpan={colspan}
                style={{ backgroundColor: '#e6e6e6', textAlign: positionText }}
              >
                <label style={{ fontSize: '17px' }}>{labelText}</label>
              </td>
            );
          })}
        </tr>
        <tr>
          {keysValues.map((value, indexType1) => {
            let valueText = valueOrDefault(value);
            if (keysLabel[indexType1] === 'mash_control') {
              valueText = valueText ? intl.formatMessage({ id: 'yes' }) : 'NO';
            }
            if (Array.isArray(value)) {
              valueText =
                value.length > 0 ? value.join(', ') : 'unregisteredValue';
            }
            const indexKeys = Math.floor(Math.random() * 10001);
            return (
              <td
                key={`valueType1-${indexKeys}`}
                colSpan={colspan}
                style={{ textAlign: positionText, width: percentageWidth }}
              >
                <span
                  style={{
                    fontSize: '17px',
                    color:
                      valueText === 'unregisteredValue' ? '#ff0000' : undefined,
                  }}
                >
                  {valueText === 'unregisteredValue'
                    ? intl.formatMessage({ id: 'unregisteredValue' })
                    : valueText}
                </span>
              </td>
            );
          })}
        </tr>
      </>
    );
  } else {
    return (
      <tr>
        {keysLabel.map((label, index) => {
          let labelText = '';
          let backColor = '#e6e6e6';
          let valueText = valueOrDefault(keysValues[index]);
          let indexKeys = Math.floor(Math.random() * 10001);
          if (label === 'none') {
            backColor = '#FFFFFF';
            return (
              <td
                key={`whiteSpace-${indexKeys}`}
                colSpan="6"
                style={{ width: '50%' }}
              ></td>
            );
          } else {
            labelText = formatLabel(label);
            return keysLabel.map((v, i) => {
              if (i === 0) {
                return (
                  <td
                    key={label}
                    colSpan="3"
                    style={{
                      backgroundColor: backColor,
                      textAlign: positionText,
                      width: '25%',
                    }}
                  >
                    <label style={{ fontSize: '17px' }}>{labelText}</label>
                  </td>
                );
              } else {
                return (
                  <td
                    key={`${label}-indexKeys`}
                    colSpan="3"
                    style={{ width: '25%' }}
                  >
                    <span
                      style={{
                        fontSize: '17px',
                        color:
                          valueText === 'unregisteredValue' ? '#ff0000' : undefined,
                      }}
                    >
                      {valueText === 'unregisteredValue'
                        ? intl.formatMessage({ id: 'unregisteredValue' })
                        : valueText}
                    </span>
                  </td>
                );
              }
            });
          }
        })}
      </tr>
    );
  }
};

AccionaTableDeliveryROW.propTypes = {
  datas: PropTypes.object.isRequired,
  text_align: PropTypes.string,
  type: PropTypes.string,
};

AccionaTableDeliveryROW.defaultProps = {
  text_align: undefined,
  type: undefined,
};

export default AccionaTableDeliveryROW;
